import React from "react";
import { Typography, Snackbar, Button, Box, Container } from "@mui/material";

export default function ({
  open,
  handleClose,
  message,
  button = 0,
  btn1Label,
  btn2Label,
  btn1OnClick,
  btn2OnClick,
  sx,
}) {
  return (
    <Snackbar
      sx={{
        backgroundColor: "#1F1F1F",
        borderRadius: "4px",
        padding: "16px",
        margin: "auto",
        width: { xs: "95vw", md: "343px" },
        height: { xs: button != 0 ? "92px" : "56px", md: "56px" },
        ...sx,
      }}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      open={open}
      autoHideDuration={2000}
      onClose={handleClose}
      autoHideDuration={3600000}
    >
      <Container
        disableGutters
        sx={{
          display: { xs: "block", md: "flex" },
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          variant="body1"
          fontWeight="400"
          fontSize="16px"
          lineHeight="24px"
          color="#EBEBEB"
        >
          {message}
        </Typography>
        {button != 0 && (
          <Box
            sx={{ display: { xs: "flex", md: "block" }, justifyContent: "end" }}
          >
            {button == 2 && (
              <Button variant="text" onClick={btn2OnClick}>
                <Typography
                  variant="subtitle1"
                  fontWeight="600"
                  fontSize="16px"
                  lineHeight="24px"
                  color="#BCE4F9"
                >
                  {btn2Label}
                </Typography>
              </Button>
            )}
            <Button variant="text" onClick={btn1OnClick}>
              <Typography
                variant="subtitle1"
                fontWeight="600"
                fontSize="16px"
                lineHeight="24px"
                color="#BCE4F9"
              >
                {btn1Label}
              </Typography>
            </Button>
          </Box>
        )}
      </Container>
    </Snackbar>
  );
}
